import React, { useState, useContext, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Autocomplete } from "@mui/material";
import {
  Grid,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import parse from "html-react-parser";
import moment from "moment";
import { toast } from "react-toastify";
import cloneDeep from "lodash/cloneDeep";
import UserContext from "../../components/context/userContext";
import {
  processHtmlWithImages,
  replaceImageSrcRegex
} from '../../utils/common/richTextFileuploads'
import cardDetailsService from "../../services/api/cardDetailsService";
import { getInitials } from "../../utils/common";
import RichTextEditor from "../RichTextEditor";
import { UserIcon, CommentContent, CommentAction } from "./styles";
import CardView from "../../containers/Card/cardView";
import attachmentService from "../../services/api/attachmentService";
import AlertUnSavedDialog from "../../components/alert/alertUnSavedComponent";

const errorConfig = {
  position: "top-center",
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const CardComments = ({
  data,
  boardData,
  getSuccessComments,
  allComments,
  commentValue,
  getCommentValue,
  close,
  childCommentsShow,
  onUnsavedChange,
  onClearComments,
}) => {

  // state declarations
  const [comment, setComment] = useState(commentValue || "");
  const [parsedAllComments, setParsedAllComments] = useState([]);
  const [initialComment, setInitialComment] = useState("");
  const [initialUpdateComment, setInitialUpdateComment] = useState("");
  const [unSavedCloseAlert, setUnSavedCloseAlert] = useState(false);
  const [isEditClose, setIsEditClose] = useState(false);

  useEffect(() => {
    setInitialComment("");
  }, []);

  useEffect(() => {
    console.log('akas commentValue '+JSON.stringify(allComments))
    if (allComments && allComments.length > 0) {
      allComments.map((item) => {
        if (item.comment_image_reference && item.comment_image_reference.length > 0) {
          /* item.comment_image_reference.map((image) => {
            const key = image.key;
            const path = image.path;
            const filename = image.filename;
            if (item.comment && item.comment.length > 0) {
              item.comment = item.comment.replace(
                new RegExp(key, "g"),
                path
              );
            }
          }); */
          if(item.comment_image_reference && item.comment_image_reference.length > 0) {
            item.comment = replaceImageSrcRegex(item.comment, item.comment_image_reference);
          }
        }
      })
    }
    setParsedAllComments(allComments || []);
  }, [allComments]);

  const { board } = useContext(UserContext);


  const [commentEdit, setCommentEdit] = useState(false);

  const [editIndex, setEditIndex] = useState(1000);
  const [updateComment, setUpdateComment] = useState("");
  const [alertCommentOpen, setAlertCommentOpen] = useState(false);
  const [itemId, setItemId] = useState(0);
  const [preloader, setPreLoader] = useState(false);
  const [showChildComments, setShowChildComments] = useState(false);
  const [childCardComments, setChildCardComments] = useState([]);
  const [childCardCommentsCopy, setChildCardCommentsCopy] = useState([]);

  const [childCardOptions, setChildCardOptions] = useState([]);
  const [childCard, setChildCard] = useState("All");
  const [isLoading, setIsLoading] = useState(false);

  const handleCommentChange = (value) => {
    setComment(value);
    getCommentValue(value);
  };

  useEffect(()=>{
    if (onUnsavedChange) {
      onUnsavedChange(isCommentChanged());
    }
  },[comment]);

  // Function to validate images without uploading
  const validateImages = (htmlString) => {
    return new Promise((resolve, reject) => {
      if (!htmlString.includes('data:image/')) {
        resolve(true);
        return;
      }
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, 'text/html');
      const imgs = doc.querySelectorAll('img');
      let validationPromises = [];
      
      Array.from(imgs).forEach((imgElement) => {
        const src = imgElement.getAttribute('src');
        if (src?.startsWith('data:')) {
          const promise = new Promise((imgResolve, imgReject) => {
            const img = new Image();
            img.onload = () => imgResolve(true);
            img.onerror = () => imgReject(new Error('Corrupted image'));
            img.src = src;
          });
          validationPromises.push(promise);
        }
      });
      
      if (validationPromises.length === 0) {
        resolve(true);
      } else {
        Promise.all(validationPromises)
          .then(() => resolve(true))
          .catch(() => reject(new Error('Corrupted image detected')));
      }
    });
  };

  const addComment = async () => {
    setIsLoading(true);
    const input = {
      id: data.id,
      author: board.name,
      comment: '',
      cardname: data.title,
      header: data.header ? data.header : null,
      boardid: boardData.id,
      boardName: boardData.name,
    };
    try {
      await validateImages(comment.toString());
    } catch (error) {
      toast.error("Corrupted or invalid image detected. Please remove and try again.", errorConfig);
      setIsLoading(false);
      return;
    }
    cardDetailsService.addComments(input).then(
      async (response) => {
        let cardcommentId = response.data.id;
        let cardComment;
        cardComment = await processHtmlWithImages(
          'card_comment',data.id, cardcommentId, comment,
          []);
        console.log('akas cardComment '+JSON.stringify(cardComment))
        let cardCommentImages = cardComment.images || [];
        cardComment = cardComment.parsedHtml;

        setPreLoader(true);
        const input = {
          commentid: cardcommentId,
          id: data.id,
          author: board.name,
          cardname: data.title,
          header: data.header ? data.header : null,
          boardid: boardData.id,
          boardName: boardData.name,
          comment: cardComment,
          comment_image_reference: cardCommentImages,
          createComment: true
        };
        cardDetailsService.postComments(input).then(
          (response) => {
            getSuccessComments();
            setUpdateComment("");
            setPreLoader(false);
            setIsLoading(false);
          },
          (error) => {
            const errorMessage =
              error.response.data.message ||
              "Something went wrong. Please contact your Administrator!";
            toast.error(errorMessage, errorConfig);
            setIsLoading(false);
          }
        );
        setCommentEdit(false);
        
        // getSuccessComments();
        setComment("");
        setInitialComment("");
        setParsedAllComments("");
        getCommentValue("");
        if (onUnsavedChange) {
          onUnsavedChange(false);
        }
      },
      (error) => {
        const errorMessage =
          error.response.data.message ||
          "Something went wrong. Please contact your Administrator!";
        toast.error(errorMessage, errorConfig);
        setIsLoading(false);
      }
    );
  };
  const cancelChildComments = () => {
    setShowChildComments(false);
  };
  const getChildCardComments = () => {
    setShowChildComments(true);
    cardDetailsService.getchildCardComments(data.id).then(
      (response) => {
        const data = cloneDeep(response.data[0].childcard_array);
        const dataCopy = cloneDeep(response.data[0].comments_array);
        data.splice(0, 0, {
          title: "All",
          id: "All",
        });
        setChildCardOptions(data);
        setChildCardComments(dataCopy);
        setChildCardCommentsCopy(dataCopy);
      },
      (error) => {
        const errorMessage =
          error.response.data.message ||
          "Something went wrong. Please contact your Administrator!";
        toast.error(errorMessage, errorConfig);
      }
    );
  };

  const parseHtml = (htmlMessage) => {
    let returndata = "null";
    if (htmlMessage) {
      returndata = parse(htmlMessage);
    }
    return returndata;
  };

  const handleEdit = (uComment, idx) => {
    setCommentEdit(true);
    setUpdateComment(uComment);
    setInitialUpdateComment(uComment);
    setEditIndex(idx);
  };

  const changeChildCard = (value) => {
    setChildCardComments([]);
    const dataCopy = cloneDeep(childCardCommentsCopy);
    if (value.id === "All") {
      setTimeout(() => {
        setChildCardComments(dataCopy);
      }, 75);
    } else {
      const filteredComments = dataCopy.filter((item) => item.id === value.id);
      setTimeout(() => {
        setChildCardComments(filteredComments);
      }, 75);
    }
    setChildCard(value);
  };

  // Edit: handle comment changes
  const handleUpdateCommentChange = (value) => {
    setUpdateComment(value);
    if (onUnsavedChange) {
      onUnsavedChange(value !== initialUpdateComment);
    }
  };
  // Updating data from CardDetailsService file
  const updateComments = async (commentId) => {
    setPreLoader(true);
    let cardComment;
    try {
      cardComment = await processHtmlWithImages(
      'card_comment',data.id, commentId, updateComment,
      [])
    } catch (error) {
      toast.error("Corrupted or invalid image detected. Please remove and try again.", errorConfig);
      return;
    }
    // updateComment = cardComment.parsedHtml;
    let updateComment1 = cardComment.parsedHtml;
    setUpdateComment(cardComment.parsedHtml);
    let commentJsonObject = allComments.filter(i => i.id === commentId)[0];
    let comment_images_update = commentJsonObject?.comment_image_reference?.filter(i => updateComment1.includes(i.key) ||updateComment1.includes(i.path) )
    if (comment_images_update && comment_images_update.length) {
      comment_images_update = comment_images_update.concat(
        cardComment.images || [])
    }
    let comment_images =  commentJsonObject?.comment_image_reference?.length > 0 && comment_images_update.length  ? comment_images_update : cardComment.images || [];
    let comment_delete = commentJsonObject?.comment_image_reference?.length > 0 ? commentJsonObject?.comment_image_reference?.filter(i => !updateComment1.includes(i.key) && !updateComment1.includes(i.path)) : [];
    let cardCommentImages = comment_images || [];
    const input = {
      commentid: commentId,
      id: data.id,
      comment: updateComment1,
      comment_image_reference: cardCommentImages,
      createComment: false
    };
    if (comment_delete && comment_delete.length > 0) {
        comment_delete.map((item) => {
          let pathToDelete = item.path
          const urlObj = new URL(pathToDelete);
          const filepaths = urlObj.searchParams.get('filepath');
          attachmentService.deleteFileByPath(filepaths).then(
            (response) => {
              console.log("Comment Attachment deleted successfully");
            },
            (error) => {
              const errorMessage =
                error.response.data.message ||
                "Something went wrong. Please contact your Administrator!";
              toast.error(errorMessage, errorConfig);
            }
          );
        });
      }
    cardDetailsService.postComments(input).then(
      (response) => {
        getSuccessComments();
        setUpdateComment("");
        setInitialUpdateComment("");
        setPreLoader(false);
        if (onUnsavedChange) {
          onUnsavedChange(false);
        }
      },
      (error) => {
        const errorMessage =
          error.response.data.message ||
          "Something went wrong. Please contact your Administrator!";
        toast.error(errorMessage, errorConfig);
      }
    );
    setCommentEdit(false);
  };
  // Editing comment for close Function
  const handleCloseComment = () => {
    if (updateComment !== initialUpdateComment) {
      setUnSavedCloseAlert(true);
      setIsEditClose(true);
    } else {
      setCommentEdit(false);
    }
  };
  // Delete Comments
  // Calling data from CardDetailsService file
  const handleAlertDialog = (flag, commentId) => {
    setAlertCommentOpen(flag);
    setItemId(commentId);
  };
  // Deleting data from CardDetailsService file
  const handleAcceptDelete = (commentId) => {
    setAlertCommentOpen(false);
    cardDetailsService.deleteComments(commentId, data.id).then(
      (response) => {
        getSuccessComments();
        setUpdateComment("");
      },
      (error) => {
        const errorMessage =
          error.response.data.message ||
          "Something went wrong. Please contact your Administrator!";
        toast.error(errorMessage, errorConfig);
      }
    );
  };

  const isCommentChanged = () => {
    return comment !== initialComment && comment !== null && comment !== "" && comment !== "<p><br></p>";
  };

  const isEditCommentChanged = () => {
    return updateComment !== initialUpdateComment && commentEdit;
  };

  const cancelFunc = () => {
    if (showChildComments) {
      cancelChildComments();
    } else {
      handleCloseCheck();
    }
  };

  const handleCloseCheck = () => {
    if (isCommentChanged() || isEditCommentChanged()) {
      setUnSavedCloseAlert(true);
      setIsEditClose(false);
    } else {
      close();
    }
  };

  const alertCloseUnsavedClose = (_event, reason) => {
    if (reason && reason === "backdropClick") return;
    setUnSavedCloseAlert(false);
  };

  const confirmUnsavedClose = () => {
    setUnSavedCloseAlert(false);
    if (commentEdit && isEditClose) {
      setCommentEdit(false);
      setUpdateComment("");
      setInitialUpdateComment("");
      if (onUnsavedChange) {
        onUnsavedChange(false);
      }
    } else {
      setComment("");
      setInitialComment("");
      if (onClearComments) {
        onClearComments();
      }
      close();
    }
    setIsEditClose(false);
  };

  const canEditOrAddComments =
    boardData.userPermission &&
    boardData.userPermission.permission.includes("card_edit");
  return (
    <div>
      {childCommentsShow && !showChildComments ? (
        <Button
          onClick={getChildCardComments}
          variant="outlined"
          color="primary"
          className="pull-right"
        >
          Child Card Comments
        </Button>
      ) : null}

      <Grid container spacing={1}>
        {showChildComments ? (
          <>
            <Grid
              item
              xs={2}
              sm={1}
              md={4}
              className="userIcon"
              style={{
                marginBottom: 20,
              }}
            >
              {childCardComments.length ? (
                <Autocomplete
                  id="boards-childdetails"
                  options={childCardOptions}
                  getOptionLabel={(option) =>
                    option.title ? option.title : option
                  }
                  value={childCard}
                  onChange={(event, value) =>
                    value ? changeChildCard(value) : null
                  }
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      label="Child Card"
                      placeholder="Search child card"
                    />
                  )}
                />
              ) : null}
            </Grid>
            {/* {childCardComments.map((childcomment, i) => ( */}
            {childCardComments.map((item, i) => (
              <Grid
                container
                spacing={1}
                key={item.id}
                style={{
                  marginLeft: 10,
                }}
              >
                <Grid item xs={2} sm={1} md={1} className="userIcon">
                  <div>
                    <CardView
                      commentCard
                      unlink
                      cardDetails={item}
                      boardId={item.boardid}
                      parentCardBoard={
                        item.boardid.toString() !== boardData.id.toString()
                      }
                      boardDetails={boardData}
                    />
                  </div>
                </Grid>

                <Grid item xs={2} sm={1} md={1} className="userIcon">
                  {item.username && item.username.profile_picture ? (
                    <img
                      src={item.username.profile_picture}
                      height={30}
                      width={30}
                      alt=""
                      style={{
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <UserIcon>
                      <div>
                        {getInitials(
                          item.username && item.username.lname
                            ? `${item.username.lname} ${
                                item.username.fname.split(" ")[0]
                              }`
                            : item.author.toString()
                        )}
                      </div>
                    </UserIcon>
                  )}
                </Grid>
                <Grid
                  item
                  xs={7}
                  sm={8}
                  md={8}
                  style={{
                    paddingTop: 10,
                    borderTop:
                      i > 0 &&
                      new Date(item.created).getDate() !==
                        new Date(childCardComments[i - 1].created).getDate()
                        ? "1px solid rgba(0, 0, 0, 0.12)"
                        : "none",
                  }}
                >
                  <div>
                    <b
                      style={{
                        fontSize: 14,
                      }}
                    >
                      {item.username && item.username.dname
                        ? item.username.dname
                        : item.author}
                    </b>
                    &nbsp;&nbsp;on&nbsp;
                    {moment(item.created).format("DD-MMM-YYYY hh:mm A")}
                  </div>
                  <CommentContent>
                    <div className="ql-editor">{parseHtml(item.comment)}</div>
                  </CommentContent>
                </Grid>
              </Grid>
            ))}
          </>
        ) : (
          <div>
            <label className="cardContainerLabel" htmlFor="Description">
              <span>Comment</span>
            </label>
            <div
              style={{
                width: "100%",
                marginTop: "20px",
              }}
            >
              <RichTextEditor
                showTablesModule="true"
                boardid={data.boardid || boardData.id}
                mentionsRequried="true"
                editorValue={comment}
                handleEditorChange={handleCommentChange}
              />
            </div>
            <div
              style={{
                margin: 10,
              }}
            >
              {canEditOrAddComments && (
                <Button
                  onClick={addComment}
                  disabled={
                    isLoading || !comment || comment === "" || comment === "<p><br></p>"
                  }
                  variant="contained"
                  color="primary"
                >
                  Add
                </Button>
              )}
            </div>
            {parsedAllComments && parsedAllComments.length ? parsedAllComments.map((item, i) => (
              <Grid
                container
                spacing={1}
                key={item.id}
                style={{
                  marginLeft: "10px",
                }}
              >
                <Grid item xs={2} sm={1} md={1} className="userIcon">
                  {item.username && item.username.profile_picture ? (
                    <img
                      src={item.username.profile_picture}
                      height={30}
                      width={30}
                      alt=""
                      style={{
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <UserIcon>
                      <div>
                        {getInitials(
                          item.username && item.username.lname
                            ? `${item.username.lname} ${
                                item.username.fname.split(" ")[0]
                              }`
                            : item.author.toString()
                        )}
                      </div>
                    </UserIcon>
                  )}
                </Grid>
                <Grid item xs={7} sm={8} md={8}>
                  <div>
                    <b
                      style={{
                        fontSize: 14,
                      }}
                    >
                      {item.username && item.username.dname
                        ? item.username.dname
                        : item.author}
                    </b>
                    &nbsp;&nbsp;on&nbsp;
                    {moment(item.created).format("DD-MMM-YYYY hh:mm A")}
                  </div>
                  {commentEdit && i === editIndex ? (
                    <div>
                      <RichTextEditor
                        showTablesModule="true"
                        boardid={data.boardid || boardData.id}
                        mentionsRequried="true"
                        editorValue={updateComment}
                        handleEditorChange={handleUpdateCommentChange}
                      />
                      <IconButton
                        style={{
                          float: "right",
                        }}
                        onClick={handleCloseComment}
                        size="large"
                      >
                        <CloseIcon color="error" />
                      </IconButton>
                      <IconButton
                        style={{
                          float: "right",
                          opacity:
                            !updateComment ||
                            updateComment === "" ||
                            updateComment === "<p><br></p>"
                              ? 0.4
                              : 1,
                        }}
                        disabled={
                          !updateComment ||
                          updateComment === "" ||
                          updateComment === "<p><br></p>"
                        }
                        onClick={() => updateComments(item.id)}
                        size="large"
                      >
                        <DoneIcon color="primary" />
                      </IconButton>
                    </div>
                  ) : (
                    <CommentContent>
                      <div className="ql-editor">{parseHtml(item.comment)}</div>
                    </CommentContent>
                  )}
                </Grid>
                {(!commentEdit || i !== editIndex) && (
                  <Grid item xs={2} sm={2} md={2}>
                    {board.name &&
                    item.author.toLowerCase() === board.name.toLowerCase() ? (
                      <CommentAction>
                        {canEditOrAddComments && (
                          <>
                            <IconButton
                              aria-label="edit"
                              onClick={() => handleEdit(item.comment, i)}
                              disabled={item.value}
                              size="large"
                            >
                              <EditIcon color="primary" />
                            </IconButton>
                            <IconButton
                              aria-label="delete"
                              onClick={() => handleAlertDialog(true, item.id)}
                              size="large"
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          </>
                        )}
                      </CommentAction>
                    ) : null}
                  </Grid>
                )}
              </Grid>
            )) : null}
          </div>
        )}
        <DialogActions className="dialogAction">
          <Button
            style={{
              marginRight: 10,
            }}
            variant="outlined"
            onClick={cancelFunc}
            color="default_button"
          >
            {showChildComments ? "Cancel" : "Close"}
          </Button>
        </DialogActions>
        {
          alertCommentOpen &&
          <Dialog
            aria-labelledby="simple-dialog-title"
            open={alertCommentOpen}
          >
            <DialogTitle
              id="alert-dialog-title"
              color="black"
            >
              Delete Comment
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure want to delete comment?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => handleAcceptDelete(itemId)}
                color="primary"
              >
                Yes
              </Button>
              <Button
                onClick={() => setAlertCommentOpen(false)}
                color="primary"
              >
                No
              </Button>
            </DialogActions>
          </Dialog>
        }
      </Grid>
      <AlertUnSavedDialog
        handleClose={alertCloseUnsavedClose}
        alertopen={unSavedCloseAlert}
        message="You have unsaved changes, please confirm you want to discard them"
        key="alertunsaveditems"
        type="closebutton"
        title="Alert"
        confirmbutton
        confirmFunc={confirmUnsavedClose}
        loader={false}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  // const stateIds = stateIdsForCurrentBoardSelector(state, ownProps.boardId);
});

const mapDispatchToProps = (dispatch, { boardId }) =>
  bindActionCreators(
    {
      // onBoardFetch: () => fetchBoard(boardId),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CardComments);
